<template>
  <v-card class="mx-auto">
    <v-data-table :headers="headers" :items="customers" :items-per-page="30" show-expand :expanded.sync="expanded">

      <template v-slot:item.actions="{ item }">

        <v-btn icon small class="ma-2" @click="addMerch(item)">
          <v-icon left>mdi-basket-plus</v-icon>
        </v-btn>

        <v-btn v-if="item.status >= 1" icon small class="ma-2" @click="edit(item)">
          <v-icon left>mdi-pencil</v-icon>
        </v-btn>
        <!-- <v-btn v-if="item.status <= 0 && item.paymentMethod != 'refunded'" icon small @click="refund(item)">

              <v-icon v-if="item.paymentMethod == 'CC'">mdi-credit-card-refund</v-icon>
              <v-icon v-else>mdi-cash-refund</v-icon>
            </v-btn> -->
        <div v-if="item.paymentMethod == 'refunded'">
          <v-chip label color="gray lighten-4" text-color="#999999">
            Refunded
          </v-chip>
        </div>

        <StatusChip v-if="item.status != 2" :status="item.status" />
      </template>


      <template v-slot:expanded-item="{ headers, item }">

        <td :colspan="headers.length" v-if="item.notes || item.merch.length > 0">
          <Bill :items="item.merch" :status="item.status" :customer_id="item.customer_id" />
          <p>Notes: {{ item.notes }}</p>
        </td>
      </template>
    </v-data-table>


  </v-card>
</template>
<style>
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none
}

th {
  text-align: left;
}
</style>
<script>
import { mapState } from 'vuex'
import StatusChip from '../components/StatusChip.vue'
import Bill from '../components/Bill.vue'

export default {
  components: {
    StatusChip,
    Bill
  },

  data: () => ({

    headers: [
      { text: '', align: 'start', value: 'ExpandAll', },
      { text: 'Pckg', align: 'start', sortable: true, value: 'code', },
      { text: 'Jumper', align: 'start', sortable: true, value: 'fullName', },
      // { text: 'Addons', align: 'start', sortable: true, value: 'billItems', },
      { text: '', value: 'actions', sortable: false },
    ],

    openExpand: true

  }),

  mounted() {

    //this.$store.dispatch('fetchCustomersWithAddons')

  },


  computed: {

    //...mapState(['customers']),
    customers() {

      return this.$store.getters.checkedin

    },


    expanded: {

      get() {
        if (this.openExpand == true)
          return this.customers
        else return []
      },

      set(items) {
        return items
      }
    },


  },

  // watch : {

  // },

  methods: {

    edit(item) {
      this.$emit('edit-checkedIn', item)
    },

    addMerch(item) {
      this.$emit('addMerchStep', item)

    },


  }

}
</script>